module.exports = __webpack_public_path__ + "img/thumbnail_Koala_m_albino.506c08e2.png";